import { CardData } from '../../../../print-cards/card-data';
import { Type } from '@angular/core';
import { CardBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/card-background.component';
import { PrintCardContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/shared/print-card-content.component';
import { PaperSize } from '../../../../shared/paper-size';
import { AddressCardStack } from './address-card-stack';
import { StiiizyAddressCardStackContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/address-cards-1x3/stiiizy-address-card-stack-content/stiiizy-address-card-stack-content.component';

export class StiiizyAddressCardStack extends AddressCardStack {
  getCardContentComponent(cardData: CardData): Type<PrintCardContentComponent> | null {
    return StiiizyAddressCardStackContentComponent;
  }

  getCardBackgroundComponent(cardData: CardData): Type<CardBackgroundComponent> | null {
    // artificial white border around card, so background is included within content component
    return null;
  }

  getCardHeightInInches(): number {
    return 1.25;
  }

  nCardsPerPage(paperSize: PaperSize, isOnPerforatedPaper: boolean): number {
    return 12;
  }

  nRows(): number {
    return 6;
  }

  nonPerforatedBleedBorderInInches(): number {
    // artificial white border around card, so background is included within content component
    return 0;
  }
}
